import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
//Srcs
import { AuthContext } from "../../Context/AuthContext";
import "../../Style/pagestyle.scss";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";

import { useGetCapitalProvince } from "../../Hooks/useGetCapitalProvince";
import { ButtonCreate, PageHeaderTitle } from "../../Utils/Component";

import useWithDimension from "../../Hooks/useWithDimension";
import CapitalProvinceForm from "../../Components/CapitalProvince/CapitalProvinceForm";
import CapitalProvinceAction from "../../Components/CapitalProvince/CapitalProvinceAction";
import { useNavigate } from "react-router-dom";

export default function CapitalProvince() {
  const { t } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const { refetch, loading, tableData, setLoading } = useGetCapitalProvince();
  const handleNavigateProvinceDetailds = (id) => {
    navigate(`/setting/capital-province/district?provinceId=${id}`);
  };

  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();
  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_province")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <CapitalProvinceForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_code")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_name")}(KH)
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_name")}(ENG)
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_type")}
                </TableCell>


                <TableCell className={t("class-name-header-title")}>

                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="7%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={7}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={7} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>

                            <TableCell
                              className="body-cell-start"
                              onClick={() => handleNavigateProvinceDetailds(row?._id)}
                            >
                              {index + 1}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigateProvinceDetailds(row?._id)}
                            >
                              {row?.capital_province_code}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigateProvinceDetailds(row?._id)}
                            >
                              {row?.capital_province_name_kh}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigateProvinceDetailds(row?._id)}
                            >
                              {row?.capital_province_name_en}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigateProvinceDetailds(row?._id)}
                            >
                              {row?.capital_province_type === "capital" ? t("thead_capital") : t("thead_province")}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigateProvinceDetailds(row?._id)}
                            >
                              {row?.isDefault && t("thead_default")}
                            </TableCell>

                            <TableCell className="body-cell-end" align="right">
                              <CapitalProvinceAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>

                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
